import React, { Component } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CustomLoader from '../../../common/CustomLoader';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import * as actions from '../../redux/actions';
import { iconForField } from '../../../../common/custom/icon-library';
import history from '../../../../common/history';
import * as externalApiActions from '../../../external-api/redux/actions';
// import CustomSessionResponseKey from './CustomSessionResponseKey';
import { getFilteredArray, processSessionKeyMapping } from './util';
import voca from 'voca';
import TooltipInfo from '../../../../common/docs/TooltipInfo';
import ConsoleLogOptions from '../../ConsoleLogOptions';
import BrowserStorageOptions from '../BrowserStorageOptions';

class SendDataToExternalApiActionForm extends Component {
  state = {
    params: [],
    formDataParams: [],
    showBSLOption: false,
    showCLOption: false,
  };

  componentDidMount() {
    const { projectId, eventAction, version } = this.props;
    this.props.externalApiActions.loadExternalApis({ projectId, version });
    const dbParams = eventAction.parameters.find((param) => {
      return param.name === 'overriddenSessionKeyRules';
    });
    const dbFormParams = eventAction.parameters.find((param) => {
      return param.name === 'overriddenSessionFormDataKeyRules';
    });
    this.setState({
      params:
        dbParams && !voca.isEmpty(dbParams.value)
          ? dbParams.value
          : [{ id: 1, originalSessionKey: '', overriddenSessionKey: '' }],
      formDataParams:
        dbFormParams && !voca.isEmpty(dbFormParams.value)
          ? dbFormParams.value
          : [{ id: 1, originalSessionKey: '', overriddenSessionKey: '' }],
    });
  }

  createNewParamRow = (rowObj) => {
    const params = processSessionKeyMapping(this.state.params, rowObj);
    this.setState({ params });
  };
  createNewFormDataParamRow = (rowObj) => {
    const formDataParams = processSessionKeyMapping(this.state.formDataParams, rowObj);
    this.setState({ formDataParams });
  };

  createActionSettingsSchema = (actionData, eventAction) => {
    let schema = {};
    actionData.args.forEach((args) => {
      const dbParameters = eventAction.parameters.find((param) => {
        return param.name === args.name;
      });
      if (dbParameters) {
        schema[args.name] = dbParameters ? dbParameters.value : '';
      } else {
        schema[args.name] = args.value || '';
      }
    });
    return schema;
  };

  handleSubmit = (values) => {
    const { actionData, eventAction, actions, projectId, version, selectedEvent } = this.props;
    const { params, formDataParams } = this.state;

    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      if (action) {
        parameters.push({ name: value, value: values[value], type: action.type });
      }
    });

    parameters.push({
      name: 'overriddenSessionKeyRules',
      value: getFilteredArray(params),
      type: 'array',
    });
    parameters.push({
      name: 'overriddenSessionFormDataKeyRules',
      value: getFilteredArray(formDataParams),
      type: 'array',
    });
    console.log(
      '🚀 ~ file: SendDataToExternalApiActionForm.js:93 ~ SendDataToExternalApiActionForm ~ parameters:',
      parameters,
    );

    let actionFormData = eventAction;
    actionFormData.parameters = parameters;

    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    this.props.hideModal();
  };

  externalApiOptions = () => {
    let options = [];
    const { externalapi, externalApiType } = this.props;
    const { externalApis } = externalapi ? externalapi : '';
    if (externalApis.length > 0) {
      if (externalApiType) {
        options = options.concat(
          externalApis
            .filter((externalApi) => externalApi.externalApiType === externalApiType)
            .map((externalAPI) => {
              return { value: externalAPI.uuid, label: externalAPI.externalApiName };
            }),
        );
      } else {
        options = options.concat(
          externalApis.map((externalAPI) => {
            return { value: externalAPI.uuid, label: externalAPI.externalApiName };
          }),
        );
      }
    }
    return options;
  };

  browserStorageLocationOptions = () => {
    let options = [
      { value: 'SESSION_STORAGE', label: 'Session Storage (Default)' },
      { value: 'LOCAL_STORAGE', label: 'Local Storage' },
      { value: 'COOKIES', label: 'Cookies' },
      { value: 'INDEXED_DB', label: 'IndexedDB' },
    ];
    return options;
  };

  closeAllOpenPopup = () => {
    const { projectId, actions, version } = this.props;
    actions.closeActionFormModal();
    history.push(`/externalapi/${version}/v/${projectId}/create`);
  };

  advanceOptionHandler = (event, name) => {
    if (name === 'passPreviousActionFormData') {
      this.setState({
        showAdvanceForPreviousActionFormData: !this.state.showAdvanceForPreviousActionFormData,
      });
    }
    if (name === 'passPreviousActionResponse') {
      this.setState({
        showAdvanceForPreviousActionResponse: !this.state.showAdvanceForPreviousActionResponse,
      });
    }
  };

  validateFormDataSessionKey = (value) => {
    console.log(
      '🚀 SendDataToExternalApiActionForm ~ CollectionActionForm validateFormDataSessionKey ~ value:',
      value,
    );
    let error;
    if (!value) {
      error = "Form Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Form Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Form Data Session Key can not be more than 50 characters';
    }
    return error;
  };
  validateResponseDataSessionKey = (value) => {
    console.log(
      '🚀 SendDataToExternalApiActionForm ~ CollectionActionForm validateResponseDataSessionKey ~ value:',
      value,
    );
    let error;
    if (!value) {
      error = "Response Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Response Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Response Data Session Key can not be more than 50 characters';
    }
    return error;
  };

  bslOptionHandler = () => {
    this.setState({
      showBSLOption: !this.state.showBSLOption,
    });
  };

  clogOptionHandler = () => {
    this.setState({
      showCLOption: !this.state.showCLOption,
    });
  };
  // TODO: Ali -> Cleanup!
  render() {
    const { eventAction, actionData } = this.props;
    const { showBSLOption, showCLOption } = this.state;
    return (
      <Formik
        enableReinitialize={true}
        initialValues={this.createActionSettingsSchema(actionData, eventAction)}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          this.handleSubmit(values);
          setSubmitting(false);
          resetForm();
        }}
      >
        {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
          <Form>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-prepend" title="Choose External API">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('select')}`}></i>
                        <span className="required"> *</span>
                      </span>
                    </div>
                    <CustomSelect
                      name={'webhookId'}
                      isMulti={false}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      options={this.externalApiOptions()}
                      value={values['webhookId']}
                      onChangeValue={this.handleChange}
                      placeholder={'External API'}
                    />
                    <ErrorMessage name={'webhookId'}>
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                    <TooltipInfo
                      title={`Select a External API from the list which you want to trigger.`}
                      headerText={`What's this ?`}
                      showHeader={true}
                      showArrow={true}
                      append={true}
                    />
                  </div>
                  <small style={{ paddingLeft: '8%' }}>
                    Select a External API that previously you've created.
                  </small>
                </div>
                <div className="form-group">
                  <div className="input-group">
                    <div className="input-group-prepend" title="Success Message">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('text')}`}></i>
                        <span className="required"> *</span>
                      </span>
                    </div>
                    <Field
                      type="text"
                      name="successMessage"
                      className="form-control form-control-sm"
                      autoComplete="off"
                      placeholder="(Optional) Success Message"
                    />
                    <ErrorMessage name="successMessage">
                      {(msg) => <p className="texterror">{msg}</p>}
                    </ErrorMessage>
                    <TooltipInfo
                      title={`Enter Success message (optional) you want to display on successful execution.`}
                      headerText={`What's this ?`}
                      showHeader={true}
                      showArrow={true}
                      append={true}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <button
                    onClick={(e) => this.bslOptionHandler(e)}
                    className="btn btn-icon-only btn-outline-info ml-5 p-1"
                    title="Show Browser Storage Options"
                    type="button"
                  >
                    <i className="wb webconnect-cog"></i>&nbsp;Browser Storage Options
                  </button>
                  <button
                    onClick={(e) => this.clogOptionHandler(e)}
                    className="btn btn-icon-only btn-outline-info ml-2 p-1"
                    title="Show Console Log Options"
                    type="button"
                  >
                    <i className="wb webconnect-cog"></i>&nbsp;Console Log Options
                  </button>
                </div>
                {showBSLOption && (
                  <BrowserStorageOptions
                    values={values}
                    setFieldValue={setFieldValue}
                    setFieldTouched={setFieldTouched}
                    validateFormDataSessionKey={this.validateFormDataSessionKey}
                    validateResponseDataSessionKey={this.validateResponseDataSessionKey}
                    sendPreviousActionResponseItemId={true}
                  />
                )}
                {showCLOption && <ConsoleLogOptions values={values} />}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 text-left">
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={this.props.hideModal}
                >
                  <span>
                    <i className="wb webconnect-times"></i> Cancel
                  </span>
                </button>
              </div>
              <div className="col-md-6 text-right">
                <button type="submit" className="btn btn-theme-submit btn-sm">
                  <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                  <CustomLoader loading={this.props.showLoaderForAction} />
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  }
}

function mapStateToProps(state) {
  return {
    event: state.event,
    externalapi: state.externalapi,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    externalApiActions: bindActionCreators({ ...externalApiActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SendDataToExternalApiActionForm);
